import { render, staticRenderFns } from "./viewAppointment.vue?vue&type=template&id=05e78b6d&scoped=true&"
import script from "./viewAppointment.vue?vue&type=script&lang=js&"
export * from "./viewAppointment.vue?vue&type=script&lang=js&"
import style0 from "./viewAppointment.vue?vue&type=style&index=0&id=05e78b6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e78b6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e78b6d')) {
      api.createRecord('05e78b6d', component.options)
    } else {
      api.reload('05e78b6d', component.options)
    }
    module.hot.accept("./viewAppointment.vue?vue&type=template&id=05e78b6d&scoped=true&", function () {
      api.rerender('05e78b6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/appointments/components/viewAppointment.vue"
export default component.exports